exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.components-input-demo-presuffix .anticon-close-circle[data-v-71a1f640] {\n  cursor: pointer;\n  color: #ccc;\n  -webkit-transition: color 0.3s;\n  transition: color 0.3s;\n  font-size: 12px;\n}\n.components-input-demo-presuffix .anticon-close-circle[data-v-71a1f640]:hover {\n  color: #f5222d;\n}\n.components-input-demo-presuffix .anticon-close-circle[data-v-71a1f640]:active {\n  color: #666;\n}\n", ""]);

// exports
